import { Button } from "@/components/ui/button";
import { useFadeIn } from "@/hooks/useFadeIn";

const MapSection = () => {
  const { ref, visible } = useFadeIn();

  return (
    <section className="bg-[#fcfaf6] py-12 md:py-16">
      <div
        ref={ref}
        className={`mx-auto grid max-w-wide grid-cols-1 gap-12 px-5 transition-all duration-700 md:px-12 lg:grid-cols-2 lg:items-center lg:gap-16 ${
          visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
        }`}
      >
        <div className="max-w-lg text-left">
          <p className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">
            Our Location
          </p>
          <h2 className="mt-3 font-headline text-[2.2rem] leading-[1.08] text-neutral-950 md:text-[3rem]">
            Visit Hadassah Homes
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-neutral-700 md:text-base">
            Conveniently located in Lynn, Massachusetts, we serve clients across
            Greater Boston and the North Shore with a strategy-first approach to
            real estate.
          </p>
          <p className="mt-4 text-sm leading-relaxed text-neutral-600 md:text-base">
            614 Washington St Suite #2, Lynn, MA
          </p>
          <Button
            variant="outline"
            size="default"
            className="mt-6 border-neutral-300 bg-transparent transition-transform duration-300 hover:-translate-y-px hover:border-accent/45"
            asChild
          >
            <a
              href="https://maps.google.com/?q=Hadassah+Homes+Lynn+MA"
              target="_blank"
              rel="noreferrer"
            >
              Get Directions
            </a>
          </Button>
        </div>

        <a
          href="https://maps.google.com/?q=Hadassah+Homes+Lynn+MA"
          target="_blank"
          rel="noreferrer"
          className="block overflow-hidden border border-neutral-200"
          aria-label="Open Hadassah Homes location in Google Maps"
        >
          {visible ? (
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2943.3577411078477!2d-70.9433054!3d42.4626796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e312d543f3ffff%3A0xce70b6289299a4a5!2sHadassah%20Homes%20Real%20Estate%20and%20Design!5e0!3m2!1sen!2sus!4v1777332974712!5m2!1sen!2sus"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Hadassah Homes map"
              className="h-[400px] w-full md:h-[420px] lg:h-[420px]"
            />
          ) : (
            <div
              className="h-[400px] w-full bg-[#f3efe7] md:h-[420px] lg:h-[420px]"
              aria-hidden="true"
            />
          )}
        </a>
      </div>
    </section>
  );
};

export default MapSection;
